import { formatMoney as shopifyFormatMoney } from '@shopify/theme-currency'

const settings = window.GM_STATE
const CENTS_IN_DOLLAR = 100

const setCorrectCentsInStringPrice = (price) => {
  if (typeof price !== 'string') return price

  // handle edge case where cents is 33.0, or 33.5 - meaning $33.00, or $33.50 respectively, but is being formatted into $3.00 or $3.50
  if (
    typeof price === 'string' && // exactly '33.5'
    price.includes('.') && // skip missing '.'
    price.split('.').length === 2 && // exclude malformed strings
    price.split('.')[1].length === 1 // '33.5' -> ['33', '5'], confirm length of cents is exactly 1, indicating ten cent intervals
  ) {
    const correctedPrice = `${price}0`

    return correctedPrice
  }

  return price
}

const getPriceString = (price) => {
  if (typeof price === 'undefined' || price === null) {
    return '0.00'
  }

  if (typeof price === 'string') {
    const correctedPrice = setCorrectCentsInStringPrice(price)

    return correctedPrice
  }

  return price.toFixed(2).toString()
}

const formatMoney = (cents, format = settings.shopify.moneyFormat) => {
  const correctedCents = setCorrectCentsInStringPrice(cents)
  const formattedMoney = shopifyFormatMoney(correctedCents, format)

  return formattedMoney
}

const formatRangePrice = (values) => values && values.map(item => formatMoney(item * CENTS_IN_DOLLAR)).join(' - ')

const getDefaultImage = (img) => (Array.isArray(img) && img.length === 0) || !img ? GM_STATE.shopify.defaultImage : img

const getSingleGraphQLId = (id, type) => `gid://shopify/${type}/${id}`

const getMultipleGraphQLIds = (ids, type) => {
  if (ids.length === 0) return []

  return ids.map((id) => getSingleGraphQLId(id, type))
}

const getIdByGraphQlId = (gid) => {
  if (typeof gid !== 'string') {
    console.error('Invalid argument: gid must be a string')

    return null
  }

  const arr = gid.split('/')

  if (arr.length === 0) {
    console.error('Invalid argument: gid must contain "/"')

    return null
  }

  return +arr[arr.length - 1]
}

const getPriceSubscription = (currentVariant, sellingPlanId, fallbackPrice) => {
  const sellingPlanAllocation = currentVariant?.sellingPlanAllocations?.find(allocation => allocation?.sellingPlanGroupId === sellingPlanId)
  const price = sellingPlanAllocation?.price || fallbackPrice

  return price
}

const getSubscriptionDiscount = (planGroups, sellingPlanId) => {
  const sellingPlan = planGroups?.find(group => group?.id === sellingPlanId)
  const priceAdjustment = sellingPlan?.selling_plans?.[0]?.price_adjustments?.[0]

  let priceAdjustmentLabel = ''

  if (priceAdjustment?.value > 0) {
    if (priceAdjustment.value_type === 'percentage') {
      priceAdjustmentLabel = `${priceAdjustment.value}%`
    } else {
      priceAdjustmentLabel = formatMoney(priceAdjustment.value)
    }
  }

  return priceAdjustmentLabel
}

const getSubscriptionSave = (planGroups, sellingPlanId) => {
  const discount = getSubscriptionDiscount(planGroups, sellingPlanId)

  return discount
}

export {
  formatMoney,
  formatRangePrice,
  getPriceString,
  getDefaultImage,
  getMultipleGraphQLIds,
  getSingleGraphQLId,
  getIdByGraphQlId,
  getPriceSubscription,
  getSubscriptionSave,
  getSubscriptionDiscount
}
